import { Form } from "schemas"

import AnalyzeVoiceForm from "./forms/AnalyzeVoiceForm"
import CreateAccountForm from "./forms/CreateAccountForm"
import GenericForm from "./forms/GenericForm"
import TypeformEmbed from "./forms/TypeformEmbed"

type Props = {
  fullWidth?: boolean
  customForm?: Form
}

function ContactForm(props: Props) {
  const { customForm } = props

  switch (customForm?.formType) {
    case "createAccount":
      return <CreateAccountForm {...props} />

    case "createAuditsAccount":
      return (
        <CreateAccountForm
          extraData={{
            auditsOnlyMode: true,
            sendInvite: false,
          }}
          {...props}
        />
      )

    case "analyzeVoice":
      return <AnalyzeVoiceForm {...props} />

    case "typeformEmbed":
      return <TypeformEmbed {...props} />

    default:
      return <GenericForm {...props} />
  }
}

export default ContactForm
export type { Props as ContactFormProps }
